import { Model, RailsFormat } from "./model"
import { Window } from "./window";
import { Day } from "./day";
import { Booking } from "./booking";
import { TutorAllocation } from "./tutor-allocation";

export class Timeslot extends Model {

  constructor(
    public bookingId?: number,
    public windowId?: number,
    public dayId?: number,

    public status: string = "",
    public period: number = null,
    public startTime: Date = null,
    public endTime: Date = null,
    public date: Date = null,

    public booking: Booking = null,
    public window: Window = null,
    public day: Day = null,

    public tutorAllocation: TutorAllocation = null,
    public replacementTutorAllocation: TutorAllocation = null,

  ) { super() }

  static clone(obj: any) {
    const ts = new this()

    if (obj.bookingId) { ts.bookingId = obj.bookingId }
    if (obj.windowId) { ts.windowId = obj.windowId }
    if (obj.dayId) { ts.dayId = obj.dayId }


    if (obj.status) { ts.status = obj.status }
    if (obj.preiod) { ts.period = parseInt(obj.period) }
    if (obj.startTime) { ts.startTime = new Date(obj.startTime) }
    if (obj.endTime) { ts.endTime = new Date(obj.endTime) }
    if (obj.date) { ts.date = new Date(obj.date) }
    
    if (obj.booking) {
      ts.booking = Booking.clone(obj.booking)
    }

    if (obj.window) {
      ts.window = Window.clone(obj.window)
    }

    if (obj.day) {
      ts.day = Day.clone(obj.day)
    }

    if (obj.tutorAllocation) {
      ts.tutorAllocation =
        TutorAllocation.clone(obj.tutorAllocation)
    }

    if (obj.replacementTutorAllocation) {
      ts.replacementTutorAllocation =
        TutorAllocation.clone(obj.replacementTutorAllocation)
    }

    return ts
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/timeslot.ts